import { useContext, useEffect, useMemo, useReducer, useState } from "react";
import Search from "../../components/search";
import "./styles.css";
import RecipeItem from "../../components/recipe-item";
import FavoriteItem from "../../components/favorite-item";
import { ThemeContext } from "../../App";
import { useCallback } from "react";

const reducer = (state, action) => {
  switch (action.type) {
    case "filteredFavorites":
      //   console.log({ ...state, filteredValue: action.value });
      return { ...state, filteredValue: action.value };

    default:
      return state;
  }
};

const initialState = {
  filteredValue: "",
};

const Homepage = () => {
  //loading state
  const { theme, setTheme } = useContext(ThemeContext);
  const [loadingState, setLoadingState] = useState(false);
  const [favoriteState, setFavoriteState] = useState([]);
  const [apiCalledSuccess, setApiCalledSuccess] = useState(false);

  //use reducer
  const [filteredState, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const ExtractFavoritesFromLocalStorageOnPageLoad =
      JSON.parse(localStorage.getItem("favorites")) || [];

    setFavoriteState(ExtractFavoritesFromLocalStorageOnPageLoad);

    console.log(favoriteState);
  }, []);

  const addToFavorites = useCallback(
    (getCurrentRecipe) => {
      let newFavorite = [...favoriteState];

      const index =
        favoriteState &&
        newFavorite.findIndex((item) => item.id === getCurrentRecipe.id);

      if (index === -1) {
        newFavorite.push(getCurrentRecipe);
        setFavoriteState(newFavorite);
        //save the favorites in local storage
        localStorage.setItem("favorites", JSON.stringify(newFavorite));
      } else {
        alert("Item is already present in favorites");
      }
    },
    [favoriteState]
  );

  const removeFromFavorites = (getCurrentId) => {
    let copyFavorite = [...favoriteState];

    const newFavorite = copyFavorite.filter((item) => item.id !== getCurrentId);

    setFavoriteState(newFavorite);
    localStorage.setItem("favorites", JSON.stringify(newFavorite));
  };

  //save result from api

  const [recipes, setRecipes] = useState([]);

  const getDataFromSearchComponent = (getData) => {
    //keep the loading state true before we call the api

    setLoadingState(true);

    //calling the api
    const getRecipes = async () => {
      const response = await fetch(
        `https://api.spoonacular.com/recipes/complexSearch?apiKey=fcffe74494404d1ebcb209eec48b3614&query=${getData}`
      );
      const result = await response.json();
      const { results } = result;

      console.log(result);

      if (results.length > 0) {
        //set loading state as false
        //fill the recipe state

        setRecipes(results);
        setLoadingState(false);
        setApiCalledSuccess(true);

        return;
      }

      setRecipes([]);
      setLoadingState(false);
    };

    getRecipes();
  };

  //FILTERED FAVORITES
  const filterFavoritesItems =
    favoriteState &&
    favoriteState.filter((item) => {
      return item.title.toLowerCase().includes(filteredState.filteredValue);
    });

  // use callback functions

  const renderRecipes = useCallback(() => {
    if (recipes && recipes.length > 0) {
      return recipes.map((item) => (
        <RecipeItem
          key={item.id}
          addToFavorites={() => addToFavorites(item)}
          item={item}
        />
      ));
    }
  }, [recipes, addToFavorites]);

  return (
    <div className="homepage">
      <Search
        getDataFromSearchComponent={getDataFromSearchComponent}
        apiCalledSuccess={apiCalledSuccess}
        setApiCalledSuccess={setApiCalledSuccess}
      />

      {/* Show favorites item */}
      <h2 style={theme ? { color: "#000" } : {}}>Favorites</h2>
      <div className="search-favorites">
        <input
          type="text"
          name="searchFavorites"
          placeholder="Search Favorite"
          onChange={(event) =>
            dispatch({
              type: "filteredFavorites",
              value: event.target.value,
            })
          }
          value={filteredState.filteredValue}
        />

        {!loadingState && !favoriteState && (
          <h1
            className="no-recipe"
            style={theme ? { color: "#000" } : { color: "" }}
          >
            No favorites are found
          </h1>
        )}
      </div>

      {filterFavoritesItems && filterFavoritesItems.length > 0 && (
        <div className="favorite">
          <div className="favorite-item">
            {filterFavoritesItems.map((item) => {
              return (
                <FavoriteItem
                  item={item}
                  key={item.id}
                  removeFromFavorites={() => removeFromFavorites(item.id)}
                />
              );
            })}
          </div>
        </div>
      )}

      {
        // Show loading state

        loadingState && (
          <div className="loading" style={theme ? { color: "#000" } : {}}>
            Loading recipes please wait
          </div>
        )
      }

      <div className="items">
        {/* {renderRecipes()} */}

        {useMemo(
          () =>
            !loadingState && recipes && recipes.length > 0
              ? recipes.map((item) => (
                  <RecipeItem
                    key={item.id}
                    addToFavorites={() => addToFavorites(item)}
                    item={item}
                  />
                ))
              : null,
          [recipes, loadingState, addToFavorites]
        )}

        {/* {useMemo(() => {
          !loadingState && recipes && recipes.length > 0
            ? recipes.map((item) => (
                <RecipeItem
                  key={item.id}
                  addToFavorites={() => addToFavorites(item)}
                  item={item}
                />
              ))
            : null,
            [loadingState, recipes, addToFavorites];
        })} */}
      </div>

      {!loadingState && !recipes.length && (
        <h1
          className="no-recipe"
          style={theme ? { color: "#000" } : { color: "" }}
        >
          No recipes are found
        </h1>
      )}
    </div>
  );
};

export default Homepage;
